<template lang="html">
	<div :class="showSidebar ? 'Calc show' : 'Calc'">
		<!-- <pre>{{data.fields}}</pre> -->
		<div class="back" @click="back">Вернутся назад</div>

		<div class="overflowContainer">
			<div class="overflow">
				<div class="serviceContainer" v-for="itemForm in data.fields">

					<p class="title">{{itemForm.title}}</p>

					<div class="item"  v-for="element in itemForm.items">
						<template v-if="element.type === 'radio'">
							<label>
								<input
									:type="element.type"
									:value="element.name"
									:name="element.radioname"
									:disabled='element.locked'
									@change='onChangeRadio($event,element)'
								/>
								<span class="text">{{element.text}}</span>

								<span v-if="element.label" class="recommend">{{element.label}}</span>
							</label>

							<div class="rside">
								<div class="rsideContainer" v-if="element.cost">
									<p class="cost" v-html="element.cost"></p>

									<div class="infoContainerWr">
										<div class="infoContainer" v-if="element.info">
											<span class="info" @click="show($event)"></span>

											<div class="infoWr">
												<div v-html="element.info"></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
						<template v-else-if="element.type === 'checkbox'">
							<label>
								<input
									:type="element.type"
									:value="element.name"
									:name="element.name"
									:disabled='element.locked'
									@change='onChange($event, element)'
								/>
								<span class="text">{{element.text}}</span>

								<span v-if="element.label" class="recommend">{{element.label}}</span>
							</label>

							<div class="rside">
								<div class="rsideContainer" v-if="element.cost">
									<p class="cost" v-html="element.cost"></p>

									<div class="infoContainerWr">
										<div class="infoContainer" v-if="element.info">
											<span class="info" @click="show($event)"></span>

											<div class="infoWr">
												<div v-html="element.info"></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>

		<div class="buttonWr">
			<div class="button buy" @click='submit' v-html='`${data.button}&nbsp;${buttonText}`'></div>

			<a class="button demo" target="_blank" :href="data.button2Href">{{data.button2}}</a>
		</div>
	</div>
</template>

<script>

module.exports = {

	props: ['data'],

	data() {
		return {
			price: 0,
			showSidebar: false,
			checkboxes: {},
			radiobox:{},
			radioButtonCost: 0,
			vw: 0
		}
	},

	computed: {
		baseCost() {

			return Number(this.data.baseCost);
		},


		buttonText() {
			return window.YAMASTERS_FRONTEND.priceMask.replace('#', +this.totalCost + +this.radioButtonCost);
		},

		totalCost() {
			return this.baseCost + this.price;
		},

		request() {
			return this.data.request;
		}
	},

	methods: {

		incrPrice(a) {
			this.price += Number(a);
		},

		decrPrice(a) {
			this.price -= Number(a);
		},

		onChangeRadio(e,el) {
			this.radioButtonCost = el.price;
			this.radiobox = el;
			// console.log(el);
		},

		onChange(e, el) {
			// console.log(e.target.checked);
			if(e.target.checked) {
				this.checkboxes[el.name] = 'Y';
				this.incrPrice(el.price);
			}
			else {
				delete this.checkboxes[el.name];
				this.decrPrice(el.price);
			}
		},

		locked(el) {
			if(el.locked) {
				this.checkboxes[el.name] = 'Y';
				this.incrPrice(el.price);
			}
		},

		show: function (e) {
			this.vw = $(window).width();

			let element = $(e.target).closest('.item').find('.infoWr');

			if(this.vw > 1024){
				if($(e.target).closest('.infoContainer').hasClass('show')){
					$(e.target).closest('.infoContainer').removeClass('show');
				}
				else {
					$('.infoContainer').removeClass('show');
					$(e.target).closest('.infoContainer').addClass('show');
				}
			}
			else{
				// console.log(element);
				$.fancybox(element);
			}
			// console.log(this.vw);
		},

		back() {
			this.showSidebar = false;
		},

		submit() {
			let form = document.createElement('form');
			form.action = this.data.form.action;
			form.method = 'post';

			if(this.radiobox){
				let input = document.createElement('input');
				input.type = 'hidden';
				input.name = this.radiobox.name;
				input.value = 'Y';
				// console.log(this.radiobox);
				// console.log(input);
				form.appendChild(input)
			}
			
			for (var chb in this.checkboxes) {
				if (this.checkboxes.hasOwnProperty(chb)) {
					let input = document.createElement('input');
					input.type = 'hidden';
					input.name = chb;
					input.value = 'Y';
					form.appendChild(input)
				}
			}

			for (var chb in this.request) {
				if (this.request.hasOwnProperty(chb)) {
					let input = document.createElement('input');
					input.type = 'hidden';
					input.name = chb;
					input.value = this.request[chb];
					form.appendChild(input)
				}
			}

			let input = document.createElement('input');
			input.type = 'hidden';
			input.name = 'TOTAL_COST';
			input.value = this.totalCost;
			form.appendChild(input);

			// console.log(form)

			document.querySelector('#body').appendChild(form);
			form.submit();
		}
	},

	watch: {
		totalCost() {
			$('#product-top-bar .sidebar-opener b:first-child').text(this.totalCost);
		},

		// data() {
		// 	this.data.fields.map(field => {
		// 		field.items.map(item => {
		// 			this.locked(item);
		// 		})
		// 	})
		// }
	},

	mounted() {

		$('#body').on('openRightSidebar', e => {
			this.showSidebar = true;
		});

	}
}
</script>

<style lang="scss">
	@import "scss/wanted";

	.Calc{
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		box-shadow: 0 0 50px rgba(#000, .1);
		transform: translateX(100%);
		background-color: white;
		z-index: 13;
		display: flex;
		flex-direction: column;
		border-radius: 3px;
		// padding: 15px;
		width: 450px;
		max-width: 100%;
		@include single-transition();
		@media (orientation: landscape) and (max-height: 640px){
			justify-content: space-around;
		}
		@include l_up{
			padding: 21px 15px 32px;
			z-index: 3;
			position: static;
			height: auto;
			transform: translateX(0) !important;
			margin: 0 0 30px;
		};
		@include l___up {
			padding: 21px 30px 32px;
		};

		&.show{
			transform: translateX(0);
		}

		.back{
			display: block;
			font-size: rem(18);
			color: #6e7074;
			font-family: $Circe_light;
			// margin-bottom: 22px;
			position: relative;
			cursor: pointer;
			flex: 0 0 auto;
			padding: 15px 15px 15px 60px;
			box-shadow: 0 0 10px #aaa;

			&:before{
				position: absolute;
				left: 15px;
				top: calc(50% - 19px);
				width: 38px;
				height: 38px;
				border-radius: 100%;
				border: 1px solid #6e7074;
				background-image: url('#{$imgPathSCSS}arr.png');
				background-position: center;
				background-repeat: no-repeat;
				content: "";
			}

			@include l_up{
				display: none;
			};
		}

		.overflowContainer{
			flex: 1 1 auto;
			position: relative;

			.overflow {
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				overflow: auto;
				padding: 10px 0 10px 15px;

				@include l_up {
					position: static;
					padding: 0;
					overflow: visible;
				};
			}
		}

		.serviceContainer{
			margin-bottom: 27px;

			.title{
				font-family: $Circe_bold;
				font-size: rem(16);
				line-height: rem(30);
				color: #303339;
				padding-bottom: 5px;
			}

			.item{
				position: relative;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 15px;
				max-width: 99%;
				@include l_up{
					max-width: 100%;
				};

				input {
					&[type="checkbox"], &[type="radio"] {
						display: none;

						&:checked {
							~ .text {
								color: #303339;
								&:after {
									opacity: 1;
									@include single-transition(all, 300ms, ease);
								}
								&:before{
									opacity: 0;
								}
							}
						}

						&:disabled ~ .text {
							// text-decoration: underline;
							opacity: .6;
							@include user-select(none);
							@include pointer-events(none);
						}
					}
				}

				.text {
					font-size: rem(15);
					line-height: .9;
					position: relative;
					padding: 0 0 0 30px;
					display: block;
					overflow-wrap: break-word;
					color: #6e7074;
					cursor: pointer;
					@include user-select(none);

					&:before {
						content: "";
						display: block;
						width: 16px;
						height: 16px;
						background-image: url("#{$imgPathSCSS}inp.png");
						position: absolute;
						top: calc(50% - 8px);
						left: 0;
						@include single-transition(all, 300ms, ease);
					}

					&:after {
						content: "";
						display: block;
						width: 17px;
						height: 16px;
						position: absolute;
						top: calc(50% - 8px);
						left: 0;
						opacity: 0;
						background-image: url("#{$imgPathSCSS}check2.png");
						@include single-transition(all, 300ms, ease);

					}

					&:hover, &.hover{
						&:after {
							color: black;
						}
					}
				}

				label{
					position: relative;
					max-width: calc(100% - 100px);
				}

				.recommend{
					display: block;
					position: absolute;
					top: -10px;
					left: 30px;
					color: #5c9d28;
					font-size: rem(9);
					letter-spacing: .05em;
					padding-left: 10px;
					font-family: $Circe_bold;
					text-transform: uppercase;
					@include user-select(none);

					&:before {
						position: absolute;
						left: 0;
						top: calc(50% - 3.5px);
						content: "";
						width: 7px;
						height: 7px;
						border-radius: 100%;
						background-color: #5c9d28;
					}
				}

				.rside{
					min-width: 100px;

					.rsideContainer{
						display: flex;
						align-items: center;
						justify-content: space-around;
					}
					.cost{
						font-size: rem(14);
						line-height: .9;
						color: #de4b39;
						padding-right: 10px;
						min-width: 70px;
						text-align: right;
					}
					.infoContainerWr{
						width: 18px;
						.infoContainer{
							position: relative;
							.info{
								width: 18px;
								height: 18px;
								display: block;
								background-image: url('#{$imgPathSCSS}info.png');
								background-size: contain;
								background-repeat: no-repeat;
								background-position: center;
								position: relative;
								z-index: 5;
								cursor: pointer;
							}
							.infoWr{
								position: absolute;
								right: 35px;
								margin-top: -50%;
								transform: translateY(-50%);
								z-index: 2;
								width: 340px;
								max-width: 250px;
								border-radius: 10px;
								background-color: #262626;
								color: white;
								font-size: rem(13);
								line-height: rem(18);
								display: none;
								opacity: 0;
								pointer-events: none;
								// transform: translateX(10px);
								@include single-transition();

								padding: 15px 20px;
								@include m_up{
									padding: 20px;
									max-width: none;
								};
								@include l_up{
									padding: 30px;
									display: block;
								};
								&:before{
									position: absolute;
									right: -40px;
									height: 40px;
									top: calc(50% - 20px);
									border: 20px solid transparent; border-left: 20px solid #262626;
									content: "";
								}
							}
							&.show{
								.infoWr{
									opacity: 1;
									pointer-events: auto;
									// transform: translateX(0);
									@include single-transition();
								}
							}
						}
					}

				}
			}
		}

		.buttonWr{
			box-shadow: 0 0 10px #aaa;
			display: flex;
			flex-direction: column;
			flex: 0 0 auto;
			padding: 10px 15px;
			@include l_up {
				box-shadow: none;
				padding: 3px 0 0;
			};

			.button{
				height: rem(61);
				width: 100%;
				max-width: 317px;
				border-radius: rem(28);
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: rem(18);
				text-decoration: none;
				cursor: pointer;
				@include single-transition();
				margin: auto;

				&.buy{
					background-color: #de4b39;
					color: white;
					@include l_up {
						margin-bottom: 15px;
					};

					&:hover{
						background-color: darken(#de4b39, 5%);
					}

					b {
						font-weight: normal;
						font-family: $Circe_bold;
					}

					i {
						font-style: normal;
						padding: 0 0 0 3px;
					}
				}

				&.demo{
					background-color: #e3de4c;
					color: #303339;
					display: none;
					@include l_up{
						display: flex;
					};
					&:hover{
						background-color: darken(#e3de4c, 5%);
					}
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// form-product-sidebar.vue?16ca78f7